import React, { memo, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { config } from '@app/config';
import { styled } from 'linaria/react';
import Image from 'next/image';
import { DEFAULT_LOCATION } from './constants';
import WrapperScroll from '../WrapperScroll/WrapperScroll';
import styles from '../BannerSlider/styles.module.scss';
import LoadMore from '../GridAds/LoadMore/LoadMore';
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w190laor"
});
const Title = /*#__PURE__*/styled("h2")({
  name: "Title",
  class: "tnqy5sa"
});
const Item = /*#__PURE__*/styled("li")({
  name: "Item",
  class: "i1jeubyn"
});
const CategoryText = /*#__PURE__*/styled("span")({
  name: "CategoryText",
  class: "coblrut"
});
const CategoryImg = /*#__PURE__*/styled("div")({
  name: "CategoryImg",
  class: "c14xr536"
});
const A = /*#__PURE__*/styled("a")({
  name: "A",
  class: "apx1hlq"
});
const WrapperCat = /*#__PURE__*/styled("a")({
  name: "WrapperCat",
  class: "w1wkvqfs"
});
const BadgeWrapperClass = /*#__PURE__*/styled("div")({
  name: "BadgeWrapperClass",
  class: "b1icfahg"
});
const BadgeClass = /*#__PURE__*/styled("span")({
  name: "BadgeClass",
  class: "bpg4fj6"
});
const Categories = ({
  region,
  allCategoriesFollowId = {},
  // orderCategories = [],
  onClick,
  handleClickMore,
  label,
  description
}) => {
  const [categoriesState, setCategoriesState] = useState([]);
  useEffect(() => {
    if (Object.keys(allCategoriesFollowId).length > 0) {
      let regionLocation = Cookies.get('regionParams');
      if (!regionLocation) {
        regionLocation = {
          regionValue: 0,
          regionUrl: '',
          regionName: 'Toàn quốc',
          subRegionValue: 0,
          subRegionUrl: '',
          subRegionName: '',
          wardValue: 0,
          wardName: '',
          wardUrl: ''
        };
      } else {
        regionLocation = JSON.parse(regionLocation);
      }
      const catList = [];
      // eslint-disable-next-line array-callback-return
      allCategoriesFollowId.map(item => {
        const cat = {
          ...item
        };
        const regionString = `${regionLocation.regionUrl}${regionLocation.subRegionUrl ? '/' + regionLocation.subRegionUrl : ''}${regionLocation.wardUrl ? '/' + regionLocation.wardUrl : ''}`;
        cat.link = `${cat.web_url && cat.web_url.replace(DEFAULT_LOCATION, regionString) || ''}`;
        cat.image = `${cat.image.replace('.png', '.svg')}`;
        catList.push(cat);
      });
      setCategoriesState(catList);
    }
  }, [allCategoriesFollowId]);
  return categoriesState.length > 0 && <Wrapper>
        <Title>{description || 'Việc làm theo ngành nghề'}</Title>
        <WrapperScroll hideIcon total={categoriesState.length} cols={categoriesState.length} mobile={{
      cols: 4.6
    }} className={styles.oneRowContent}>
          <WrapperCat>
            {categoriesState.map((item, index) => {
          item.index = index;
          return <Item key={'cat-' + index.toString()} className="slider-item">
                  <A aria-label={item.text} onClick={() => onClick(item)} href={item.link}>
                    <CategoryImg>
                      <Image src={item.image} width={52} height={52} priority={index < 9} alt={item.text} quality={95} loading={index < 9 ? 'eager' : 'lazy'} unoptimized />
                    </CategoryImg>
                    <div className="flex flex-col flex-auto">
                      <CategoryText>{item.text}</CategoryText>
                    </div>
                  </A>
                  {(item?.is_hot || item?.isNew) && <BadgeWrapperClass>
                      <BadgeClass>{item?.is_hot ? 'HOT' : 'Mới'}</BadgeClass>
                    </BadgeWrapperClass>}
                </Item>;
        })}
          </WrapperCat>
        </WrapperScroll>
        <LoadMore action="click_see_more" eventName="find_job_by_job_type" link={`${config.jobURL}/viec-lam${region.regionUrl && region.regionUrl !== 'toan-quoc' ? '-' + region.regionUrl : ''}?showModal=job_type`} label={label || 'Xem tất cả 33 ngành nghề'} total={24} handleClickLoadmore={handleClickMore} />
      </Wrapper>;
};
export default memo(Categories);

require("../../../.linaria-cache/src/components/Categories/index.linaria.module.css");